<template>
    <a href="#" class="button button--no-break cart-button" v-on:click.prevent="addOrRemove"></a>
</template>

<script>
    export default {
        name: "CartButton",
        props: {
            inline: Boolean,
            productId: String,
            cart: Boolean
        },
        data() {
            return {
                state: store.state,
                inCart: false,
                axios: window.axios
            }
        },

        mounted() {
            if (this.inline || this.cart) {
                $(this.$el).attr('style-size', 'inline');
            }

            this.update();
        },

        methods: {
            update: function () {
                this.inCart = this.state.cart.indexOf(this.productId) !== -1;

                if (this.inCart) {
                    $(this.$el).text("Remove");
                    $(this.$el).attr("style-color", 'red');
                } else {
                    $(this.$el).text("Add To Cart");
                    $(this.$el).removeAttr('style-color');
                }
            },
            addOrRemove: function () {
                if (this.inCart) {
                    this.remove();
                } else {
                    this.add();
                }
            },
            add: function () {
                let component = this;
                store.addCartItemAction(this.productId);
                this.axios.put('/purchase-shapefiles/cart/' + this.productId)
                    .then(function () {
                        component.update();
                    });
            },
            remove: function () {
                let component = this;
                if (!component.cart) {
                    store.removeCartItemAction(this.productId);
                }
                this.axios.delete('/purchase-shapefiles/cart/' + this.productId)
                    .then(function () {
                        if (component.cart) {
                            location.reload();
                        }
                        component.update();
                    });
            }
        }
    }
</script>

<style scoped>

</style>
